'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'house-chimney';
var width = 576;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M80.2 268.8l5.8-5.4 202.2-187.8 202.2 187.8 5.8 5.4 0 243.2-144 0 0-176-128 0 0 176-144 0 0-243.2z', 'M288.2-11.7c3.1 2.9 40.5 37.6 112 104l0-44.3 96 0 0 133.5c27.6 25.6 48 44.6 61.2 56.9l-43.5 46.9-23.4-21.8-202.2-187.8-202.2 187.8-23.4 21.8-43.5-46.9 23.4-21.8 224-208 21.8-20.2zM224.2 336l128 0 0 176-128 0 0-176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;